import { render, staticRenderFns } from "./ElementHomework.vue?vue&type=template&id=c4f47152&scoped=true&"
import script from "./ElementHomework.vue?vue&type=script&lang=js&"
export * from "./ElementHomework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f47152",
  null
  
)

export default component.exports